import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: Cookies.get('admin_token') || '',
    admin: JSON.parse(localStorage.getItem('admin') || '{}'),
    permissions: JSON.parse(localStorage.getItem('permissions') || '[]')
  },
  getters: {
    token: state => state.token,
    admin: state => state.admin,
    permissions: state => state.permissions
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      Cookies.set('admin_token', token)
    },
    SET_ADMIN(state, data) {
      state.admin = data
      localStorage.setItem('admin', JSON.stringify(data))
    },
    SET_PERMISSIONS(state, data) {
      state.permissions = data
      localStorage.setItem('permissions', JSON.stringify(data))
    },
    LOGOUT(state) {
      state.token = ''
      state.admin = {}
      state.permissions = []
      Cookies.remove('admin_token')
      localStorage.removeItem('admin')
      localStorage.removeItem('permissions')
    }
  }
})
